import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { NgClass } from '@angular/common';
import { PercentPipe } from '@angular/common';

@Component({
  selector: 'app-confirm',
  templateUrl: 'view-adjustments.modal.component.html',
  styleUrls: [ 'view-adjustments.modal.component.scss' ],
  providers: [BsModalService]
})

export class ViewAdjustmentsModalComponent {
  @Input() title = 'Adjustment Summary';

  constructor(public bsModalRef: BsModalRef) { }

  isNumber = (val) => {
    return !isNaN(val) && val !== '';
  }
}



// WEBPACK FOOTER //
// ./src/app/report/adjustments/components/view-adjustments.modal.component.ts